var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIconBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.679,
    height: 33.218,
    viewBox: "0 0 33.679 33.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722",
    transform: "translate(-584.807 -582.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M30.5,311.109A16.609,16.609,0,0,1,47.109,294.5h.462a16.609,16.609,0,1,1,0,33.218h-.462A16.609,16.609,0,0,1,30.5,311.109Z",
    transform: "translate(554.307 288.359)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(594.78 592.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(0 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    d: "M8.569,7.7,13.82,1.952a.877.877,0,0,0,.224-.594A.875.875,0,0,0,13.82.764l-.46-.5a.724.724,0,0,0-1.086,0L7.022,6,1.771.261a.724.724,0,0,0-1.086,0l-.46.5a.9.9,0,0,0,0,1.188L5.476,7.7.225,13.438a.9.9,0,0,0,0,1.188l.46.5a.724.724,0,0,0,1.086,0L7.022,9.387l5.251,5.743a.73.73,0,0,0,.543.245h0a.731.731,0,0,0,.543-.245l.46-.5a.9.9,0,0,0,0-1.188Z",
    transform: "translate(0 -0.016)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBg);
export default __webpack_public_path__ + "static/media/close-icon-bg.b508097aa1494027a12a9005624fb8da.svg";
export { ForwardRef as ReactComponent };